module.exports = __webpack_public_path__ + "static/plain-funcionalidades3-5a9244b15fd2b6a7db76718e6191e9ce.png";